import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { colors } from '@/styles'
import { Button } from '@/components/button'
import Icon from '@/components/icon'
import { H4, ParagraphRegular } from '@/components/text'
import Context from '../context'

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;

  svg {
    margin: 24px 0;
  }
`

const Title = styled(H4)`
  color: ${colors.black};
`

const Description = styled(ParagraphRegular)`
  color: ${colors.grey24};
`

const ButtonWrapper = styled.div`
  margin-top: 16px;
  width: 100%;
`

const ResetPasswordSuccess = () => {
  const { t } = useTranslation()
  const { setUsername, setCurrentStep } = useContext(Context)

  return (
    <Content>
      <Icon id="round_check" width={75} height={75} />
      <Title>{t('b.auth.view.password_reset_requested.text', 'Password Reset Requested')}</Title>
      <Description>
        {t(
          'b.auth.edit.reset_sent.text',
          'The password reset link will be sent to the email associated with your account. If you do not receive the reset link within 10-15 minutes, please try this process again.'
        )}
      </Description>
      <ButtonWrapper>
        <Button
          id="web-LoginSocial-reset-password-done-button"
          theme="primary"
          width="100%"
          onClick={() => {
            setUsername('')
            setCurrentStep('login')
          }}
        >
          {t('b.auth.view.reset_password.back_to_login.button', 'Back to Login')}
        </Button>
      </ButtonWrapper>
    </Content>
  )
}

export default ResetPasswordSuccess
